import {post} from '../interceptor'

let preUrl = '';
export default {
  getYuxingEnergyReport(params) { return post(preUrl, '/yuxingReport/getEnergyReport', params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/customizeManage.js